module.exports = __webpack_public_path__ + "static/dance_1920-d6c2f0559d3c8b15c6e9fa28146890b3.mp4";